export const getSameOriginUrl = (value: unknown): URL | null => {
  if (typeof value !== 'string' || !value) {
    return null;
  }

  try {
    const origin = new URL(window.location.origin);
    const url = new URL(value, origin);
    return url.protocol === origin.protocol && url.host === origin.host ? url : null;
  } catch {
    return null;
  }
};
